define('BRListrakReCart.View', [
    'PageType.Base.View',
    'BRListrakRecart.tpl',
	'Utils',
    // 'BRListrak.SS2Model',
], function (
    PageTypeBaseView,
    BRListrakRecart_tpl,
	Utils,
    // BRListrakRecartModel,
) {
    'use strict';

    return PageTypeBaseView.PageTypeBaseView.extend({
        template: BRListrakRecart_tpl,
        initialize: function (options) {
            // this.model = new BRListrakRecartModel();
        },
        beforeShowContent: function() {
            var promise = jQuery.Deferred();

            this.title = Utils.translate('Cart Recreate');
            
            promise.resolve();
            return promise;
        },
        getContext: function getContext () {
            return {
                message: "Processing your cart. Please wait!"
            }
        }
    })
});
